import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import testSlice from './slices/testSlice';
import loadingSlice from './slices/loadingSlice';
import authSlice from './slices/authSlice';
import labelsSlice from './slices/labelsSlice';
import usersSlice from './slices/usersSlice';
import restaurantSlice from './slices/restaurantSlice';
import taskSlice from './slices/taskSlice';

export const store = configureStore({
  reducer: {
    testSlice,
    loadingSlice,
    authSlice,
    labelsSlice,
    usersSlice,
    restaurantSlice,
    taskSlice,
  },
});

export const useAppDispatch = () => useDispatch();
